import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SystemEventParentType } from 'src/app/shared/enums/system-event-parent-type';
import { SystemEventType, getPrettyEventType } from 'src/app/shared/enums/system-event-type-enum';
import { InstanceService } from 'src/app/modules/instance/services/instance.service';
import { Instance } from 'src/app/modules/instance/models/instance';

@Component({
    standalone: false,
    selector: 'app-console-system-events',
    templateUrl: './console-system-events.component.html',
    styleUrls: ['./console-system-events.component.scss']
})
export class ConsoleSystemEventsComponent implements OnInit, OnDestroy {
    searchForm: FormGroup;
    instances: Instance[] = [];

    showResults: boolean = false;
    selectedStateEnv: string = '';
    selectedParentId: string = '';
    selectedParentType: SystemEventParentType = SystemEventParentType.NONE;
    selectedCreatedAtStart: string = '';
    selectedCreatedAtEnd: string = '';
    selectedEventType: SystemEventType = SystemEventType.NONE;
    refreshToken: number = 0;

    parentTypes = [
        { value: SystemEventParentType.NONE, label: 'All' },
        { value: SystemEventParentType.PROCESS, label: 'Process' },
        { value: SystemEventParentType.ZONING_CODE, label: 'Zoning Code' },
        { value: SystemEventParentType.CALCULATION_RESULT, label: 'Calculation Result' }
    ];

    eventTypes: { value: SystemEventType; label: string }[] = [];

    SystemEventParentType = SystemEventParentType;

    private destroy$ = new Subject<void>();

    constructor(private readonly fb: FormBuilder, private readonly instanceService: InstanceService) {}

    ngOnInit(): void {
        this.initForm();
        this.loadInstances();
        this.eventTypes = this.buildEventTypes();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initForm(): void {
        this.searchForm = this.fb.group({
            stateEnv: ['', Validators.required],
            parentId: [''],
            parentType: [SystemEventParentType.NONE],
            eventType: [SystemEventType.NONE],
            createdAtStart: [''],
            createdAtEnd: ['']
        });
    }

    private buildEventTypes(): { value: SystemEventType; label: string }[] {
        const values = Object.values(SystemEventType)
            .filter(value => typeof value === 'number')
            .map(value => value as SystemEventType)
            .sort((a, b) => a - b);

        return values.map(value => ({
            value,
            label: value === SystemEventType.NONE ? 'All' : getPrettyEventType(value)
        }));
    }

    private loadInstances(): void {
        this.instanceService.instances.pipe(takeUntil(this.destroy$)).subscribe(instances => {
            this.instances = instances;
        });
    }

    onSearch(): void {
        if (this.searchForm.invalid) {
            return;
        }

        const formValue = this.searchForm.value;
        this.selectedStateEnv = formValue.stateEnv;
        this.selectedParentId = formValue.parentId;
        this.selectedParentType = formValue.parentType;
        this.selectedEventType = formValue.eventType;
        this.selectedCreatedAtStart = formValue.createdAtStart;
        this.selectedCreatedAtEnd = formValue.createdAtEnd;
        this.refreshToken++;
        this.showResults = true;
    }

    onReset(): void {
        this.searchForm.reset({
            stateEnv: '',
            parentId: '',
            parentType: SystemEventParentType.NONE,
            eventType: SystemEventType.NONE,
            createdAtStart: '',
            createdAtEnd: ''
        });
        this.showResults = false;
    }
}
